import { render, staticRenderFns } from "./JobHistoryDetails.vue?vue&type=template&id=fab7b514&scoped=true&"
import script from "./JobHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./JobHistoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobHistoryDetails.vue?vue&type=style&index=0&id=fab7b514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab7b514",
  null
  
)

export default component.exports